import { cn } from "../../lib/utils";

interface ApproachStep {
  readonly label: string;
  readonly color: string; // Tailwind class like "text-approach-body"
}

interface ApproachFlowProps {
  steps: readonly ApproachStep[];
  arrowColor: string; // Tailwind class like "text-approach-arrow"
  className?: string;
}

export function ApproachFlow({ steps, arrowColor, className }: ApproachFlowProps) {
  return (
    <div className={cn("mb-8 sm:mb-10 text-center", className)}>
      <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 md:gap-4">
        {steps.map((step, index) => (
          <div key={step.label} className="flex items-center gap-2 sm:gap-3 md:gap-4">
            <span className={cn("text-lg sm:text-xl md:text-2xl font-bold font-sans", step.color)}>
              {step.label}
            </span>
            {index < steps.length - 1 && (
              <span className={cn("text-xl sm:text-2xl font-bold", arrowColor)} aria-hidden="true">
                →
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
